import { IconButton, ResetIconButton } from '@library/components/buttons';
import type {
  MemberSearchFilterParam,
  SearchFilters
} from '@library/types/members';
import { AdjustmentsHorizontalIcon } from '@heroicons/react/20/solid';
import { Searchbar } from '@library/components/inputs';
import { useCallback } from 'react';

export interface MemberFiltersProps {
  memberSearchFilters: SearchFilters;
  onChangeSearchMemberFilter: ({ key, value }: MemberSearchFilterParam) => void;
  onResetSearchMemberFilters: () => void;
  onToggleFiltersDrawer: (isOpen: boolean) => void;
}

export const MemberFilters = ({
  memberSearchFilters,
  onChangeSearchMemberFilter,
  onResetSearchMemberFilters,
  onToggleFiltersDrawer
}: MemberFiltersProps) => {
  const { email, firstName, lastName, memberId, uuid } = memberSearchFilters;

  const openFilterDrawer = useCallback(() => {
    onToggleFiltersDrawer(true);
  }, [onToggleFiltersDrawer]);

  const handleChangeSearchMemberFilter = useCallback(
    (key: keyof SearchFilters) => (value: string) => {
      onChangeSearchMemberFilter({ key, value });
    },
    [onChangeSearchMemberFilter]
  );

  return (
    <div className="flex flex-wrap items-center gap-4">
      <div className="shrink-0 basis-96">
        <Searchbar
          handleSearch={handleChangeSearchMemberFilter('memberId')}
          id="search-by-user-id"
          placeholder="Search member ID or UUID"
          searchValue={memberId || uuid}
        />
      </div>
      <div className="shrink-0 basis-60">
        <Searchbar
          handleSearch={handleChangeSearchMemberFilter('firstName')}
          id="search-by-first-name"
          placeholder="Search first name"
          searchValue={firstName}
        />
      </div>
      <div className="shrink-0 basis-60">
        <Searchbar
          handleSearch={handleChangeSearchMemberFilter('lastName')}
          id="search-by-last-name"
          placeholder="Search last name"
          searchValue={lastName}
        />
      </div>
      <div className="shrink-0 basis-72">
        <Searchbar
          handleSearch={handleChangeSearchMemberFilter('email')}
          id="search-by-email"
          placeholder="Search email"
          searchValue={email}
        />
      </div>
      <IconButton
        handleOnClick={openFilterDrawer}
        dataTestId="additional-filters-icon-button"
        className="m-0"
      >
        <AdjustmentsHorizontalIcon
          className="text-soClean-180 hover:text-soClean-100 hover:bg-soFresh-120 size-9 items-center rounded-md p-2"
          data-testid="NumberedListIcon"
        />
      </IconButton>
      <ResetIconButton
        className="disabled:text-soClean-140 !m-0 shrink-0 basis-28 !p-0"
        disabled={false}
        label="Reset Filters"
        onClick={onResetSearchMemberFilters}
      />
    </div>
  );
};
